import { LineChart, Scale, Building2, ShieldCheck } from "lucide-react";
import { ADVISORY } from "../mock";

const ICON_MAP = { LineChart, Scale, Building2, ShieldCheck };

export default function Advisory() {
  return (
    <section id="advisory" className="relative py-24 lg:py-32">
      <div className="absolute inset-0 grid-lines opacity-30" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl reveal">
          <span className="text-xs font-semibold tracking-[0.22em] text-teal-300 uppercase">
            {ADVISORY.eyebrow}
          </span>
          <h2 className="font-display font-bold text-white text-3xl lg:text-5xl mt-4 leading-tight tracking-tight">
            {ADVISORY.title}
          </h2>
          <p className="mt-6 text-slate-300/85 leading-relaxed">{ADVISORY.intro}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          {ADVISORY.services.map((s, i) => {
            const Icon = ICON_MAP[s.icon];
            return (
              <div
                key={i}
                className="reveal group relative overflow-hidden rounded-2xl border border-teal-500/12 bg-[#071815]/60 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-teal-400/30 hover:shadow-2xl hover:shadow-teal-950/40"
                style={{ transitionDelay: `${(i % 2) * 80}ms` }}
              >
                <span className="absolute left-0 top-8 h-10 w-1 rounded-r bg-gradient-to-b from-teal-400 to-emerald-500" />
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-teal-500/10 text-teal-300 transition-all group-hover:bg-teal-500/20 group-hover:scale-105">
                    {Icon && <Icon size={22} />}
                  </span>
                  <h3 className="font-display font-semibold text-white text-lg leading-snug">
                    {s.title}
                  </h3>
                </div>
                <p className="mt-5 text-slate-400 leading-relaxed text-[15px]">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}